import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export const presets = [
  {
    id: 'keitaro',
    title: 'Keitaro',
    params:
      '?subid={subid1}&status={status}&lead_status=waiting&sale_status=approved&rejected_status=declined,trash&payout={summ_approved}&currency={currency}&from=offerrum',
  },
  {
    id: 'adsbridge',
    title: 'Adsbridge',
    params:
      '?tid={subid1}&amt={summ_total}&status={status}',
  },
  {
    id: 'cpatracker',
    title: 'CPAtracker',
    params:
      '?n=custom&ak={subid2}&subid={subid1}&profit={summ_approved}',
  },
  {
    id: 'bemob',
    title: 'Bemob',
    params: '?cid={subid1}&payout={summ_approved}&txid={order_id}&status={status}',
  },
  {
    id: 'peerclick',
    title: 'PeerClick',
    params: '?userid=0000&cid={subid1}&summ_total={summ_total}&status={status}',
  },
];

export const getLink = id => {
  switch (id) {
    case 'adsbridge':
      return 'http://jkarv.adsb4trk.com/trackpixel/track';
    case 'cpatracker':
      return 'http://jne1.ru/37300/p.php';
    case 'peerclick':
      return 'http://pstb.peerclicktrk.com/postback';
    case 'bemob':
      return 'http://3gmbv.bemobtrk.com/postback';
    default:
      return 'http://example.com/stream/postback';
  }
};

export const prepareURL = ({ id, params }) => {
  const link = getLink(id);
  return link + params;
};

const GlobalPostbackPresets = ({ onPresetApply }) => (
  <div className="global-postback-presets">
    <span className="global-postback-presets-title">
      <FormattedMessage
        id="postback.global.presets.title"
        defaultMessage="postback.global.presets.title"
      />
    </span>
    {presets.map(preset => (
      <Button key={preset.id} color="link" onClick={onPresetApply.bind(null, prepareURL(preset))}>
        {preset.title}
      </Button>
    ))}
  </div>
);

export default GlobalPostbackPresets;
